import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import SearchIcon from "@material-ui/icons/Search";
import InputAdornment from "@material-ui/core/InputAdornment";
import CreateTemplateDialog from "../CreateTemplateDialog/CreateTemplateDialog";
import ProcessingDialog from "../ProcessingDialog/ProcessingDialog";
import useDocFormsStore from "../../store/docFormsStore";

import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { styled } from "@mui/material/styles";

import Dialog from "@mui/material/Dialog";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
	"& .MuiDialogContent-root": {
		padding: theme.spacing(2),
	},
	"& .MuiDialogActions-root": {
		padding: theme.spacing(1),
	},

	"& .MuiDialog-paper": {
		width: "762px",
		maxWidth: "762px",
	},
}));
const useStyles = makeStyles((theme) => ({
	appBar: {
		// Ajustes adicionales si lo deseas
	},
	toolbar: {
		display: "flex",
		flexWrap: "wrap",
		justifyContent: "space-between",
		padding: 0,
		marginTop: "24px",
	},
	leftSection: {
		display: "flex",
		alignItems: "center",
	},
	tabsContainer: {
		display: "flex",
		alignItems: "center",
		backgroundColor: "#fff",
		borderRadius: "10px",
	},
	tabs: {
		// marginRight: theme.spacing(4),
		// color: '#006ac6',
		backgroundColor: "#fff",
	},
	tab: {
		fontSize: "14px",
		textTransform: "none",
		fontWeight: 500,
	},
	rightSection: {
		display: "flex",
		alignItems: "center",
	},
	searchInput: {
		marginLeft: theme.spacing(2),
		backgroundColor: "#fff",
		width: "100%",
		height: "36px",
		textTransform: "none",
	},
	searchButton: {
		marginLeft: 4,
		textTransform: "none",
	},
	title: {
		color: "#006ac6",
		fontSize: "32px",
		margin: 0,
		padding: 0,
	},
	newTemplateButton: {
		marginLeft: "20px",
		textTransform: "none",
	},
}));

export default function TemplateHeader({ tabValue, onTabChange }) {
	const classes = useStyles();
	const [openDialog, setOpenDialog] = useState(false);
	const [showCreateDialog, setShowCreateDialog] = useState(false);
	const [showProcessing, setShowProcessing] = useState(false);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [showRequest, setShowRequest] = useState(false);

	const assignedCount = useDocFormsStore((s) => s.assignedForms.length);
	const completedCount = useDocFormsStore((s) => s.completedForms.length);

	const handleChangeTab = (event, newValue) => {
		onTabChange(newValue);
	};

	const handleOpenDialog = () => {
		setShowRequest(true);
	};

	const handleCloseDialog = () => {
		setOpenDialog(false);
	};

	const handleUpoloadDialog = async (params) => {
		
	};
	const handleUploadByDocumentId = async (documentId) => {
		
	};

	const setRequest = (item) => {
		console.log('item', item);
		setShowRequest(false);
		if (item.length > 0) {
			handleUploadByDocumentId(item[0].id);
		}
	}


	const navigateToTemplateBuilder = (documentId) => {
		navigate(`/templates-v2/template-builder/${documentId}?mode=edit`);
	};

	return (
		<div>
			<h2 className={classes.title}>DocPlace Forms</h2>
			<header position="static" className={classes.appBar}>
				<div className={classes.toolbar}>
					<div className={classes.leftSection}>
						<div className={classes.tabsContainer}>
							<Tabs
								value={tabValue}
								onChange={handleChangeTab}
								className={classes.tabs}
								indicatorColor="primary"
								textColor="primary"
							>
								<Tab
									label={assignedCount > 0 ? `Assigned ${assignedCount}` : "Assigned"}
									className={classes.tab}
								/>
								<Tab
									label={completedCount > 0 ? `Completed ${completedCount}` : "Completed"}
									className={classes.tab}
								/>
							</Tabs>
						</div>
{/* 
						<Button
							variant="contained"
							color="primary"
							className={classes.newTemplateButton}
							onClick={() => handleOpenDialog()}
						>
							New Template
						</Button> */}
					</div>

					{/* <div className={classes.rightSection}>
						<TextField
							variant="outlined"
							size="small"
							placeholder="Search"
							className={classes.searchInput}
							InputProps={{
								startAdornment: (
									<InputAdornment position="start">
										<SearchIcon color="primary" />
									</InputAdornment>
								),
							}}
						/>
						<Button
							variant="contained"
							color="primary"
							className={classes.searchButton}
						>
							Search
						</Button>
					</div> */}
				</div>
			</header>

			<CreateTemplateDialog
				open={openDialog}
				onClose={handleCloseDialog}
				onUpload={handleUpoloadDialog}
			/>
			<ProcessingDialog open={showProcessing} />
			{/* <BootstrapDialog
						onClose={() => {
							setShowRequest(false);
						}}
						aria-labelledby="customized-dialog-title"
						open={showRequest}
					>
						<NbTreeFile
							onClickClose={() => setShowRequest(false)}
							onClickRequest={setRequest}
						/>
					</BootstrapDialog> */}
		</div>
	);
}
